/**
 * Avatar initials from a display name or tenant name: the first and last
 * word's first letters ("Dana Whitfield" -> "DW", "Litware Health" ->
 * "LH"; dots, @, _ and - split words too), the first two letters of a single
 * word ("Fabrikam" -> "FA"), else the fallback.
 */
export function initialsOf(value: string | null | undefined, fallback = 'GU'): string {
  if (!value) return fallback
  const parts = value.trim().split(/[\s.@_-]+/).filter(Boolean)
  if (parts.length === 0) return fallback
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
